const EMPTY_ARRAY = Object.freeze([]);

export default EMPTY_ARRAY;
